export default "__VITE_ASSET__5c88752a__"